<template>
  <v-container :class="{ 'pa-1': $vuetify.breakpoint.xs, 'pa-2': $vuetify.breakpoint.smAndUp }" fluid>
    <v-row>
      <v-col
        :sm="small"
        :md="medium"
        :lg="large"
        :xl="xLarge"
        class="pb-2"
        :style="`height:calc(100vh - ${isToolbarsHidden ? '80px' : '103px'}) !important;overflow-y:scroll`"
      >
        <div>
          <!-- read as following: 2 columns up to 1280 page width, 3 columns from 1281 to 1980 pixels width-->
          <masonry class="masonry" :cols="{ default: 4, 1904: 3, 960: 2, 600: 1 }">
            <div v-for="item in instanceNews" :key="item.id" :class="{ item: true, 'pa-1': $vuetify.breakpoint.xs, 'pa-2': $vuetify.breakpoint.smAndUp }">
              <news-card :item="item" :moduleConfig="moduleConfig"></news-card>
            </div>
          </masonry>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import NewsCard from './NewsCard';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import moduleIndex from './index';
import readService from '@/services/readService';

export default {
  name: 'NewsMasonryView',
  components: {
    NewsCard,
  },
  mixins: [common, configMixin],
  computed: {
    ...mapState('news', ['news', 'newsById', 'dataLoaded', 'showUnreadOnly', 'usedLabels']),
    instance() {
      return Number(this.$route.params.instance);
    },
    instanceNews() {
      console.debug('instanceNews, selectedLabelId', this.selectedLabelId);
      let news;
      if (this.dataLoaded) {
        // instance filter
        news = this.news.filter((n) => n.instance === this.instance);

        // unread only filter
        if (this.showUnreadOnly) {
          news = news.filter((n) => readService.isUnread(n));
        }

        // accept selected labels only
        if (this.selectedLabelId) {
          news = news.filter((n) => {
            let labels = n._labels;
            return !!labels.find((l) => l.labelIdFk === this.selectedLabelId);
          });
        }
      }
      return news;
    },
    moduleConfig() {
      return this.getModuleConfig(moduleIndex.moduleType, this.instance);
    },
    displaySideNavigation() {
      return this.moduleConfig.hasSideNavigation ? !this.smAndDown : false;
    },
    selectedLabelId: {
      get() {
        return this.$store.state.news.selectedLabelId;
      },
      set(value) {
        console.debug('selectedLabelId', value);
        this.showUnreadOnly = false;
        this.$store.commit('news/setSelectedLabelId', value);
      },
    },

    small() {
      return this.displaySideNavigation ? 6 : 12;
    },
    medium() {
      return this.displaySideNavigation ? 8 : 12;
    },
    large() {
      return this.displaySideNavigation ? 9 : 12;
    },
    xLarge() {
      return this.displaySideNavigation ? 10 : 12;
    },
  },
};
</script>

<style scoped>
.masonry .item {
  /*margin-bottom: 3px;*/
}
</style>
